export const createMappingStructure = (materials = null, colors = null, profiles = null) => {
  const mapping = {};

  if (materials) {
    mapping.materials = materials?.map(material => ({
      ...material,
      id: `material-${material.sku_code}`,
      sku_code: material.sku_code || '',
      type: 'material',
      checked: false
    }));

    mapping.profiles = materials?.[0]?.profiles?.map(profile => ({
        ...profile,
        id: `profile-${profile.sku_code}`,
        sku_code: profile.sku_code || '',
        type: 'profile',
        checked: false,
        children: profile.width_options.map(width => ({
            ...width,
            id: `${profile.sku_code}-width-${width.width}`,
            sku_code: width.width|| '',
            type: 'width',
            checked: false
        }))
    }));
  }

  if (colors) {
    mapping.colors = colors?.map(color => ({
      ...color,
      id: `color-${color.sku_code}`,
      sku_code: color.sku_code || '',
      type: 'color',
      checked: false
    }));
  }

  if (profiles) {
    mapping.profiles = profiles.map(profile => ({
        ...profile,
        id: `profile-${profile.sku_code}`,
        sku_code: profile.sku_code || '',
        type: 'profile',
        checked: true,
        children: profile.width_options.map(width => ({
            id: `${profile.sku_code}-width-${width.width}`,
            sku_code: width.width|| '',
            base_ring_url: width.base_ring_url || '',
            type: 'width',
            checked: true,
            
        }))
    }));;
  }

  return mapping;
};


export const getSelectedMappings = (mappingData, isInside = false) => {
    const selectedMappings = [];
    const { profiles, materials, colors } = mappingData;
    const selectedMaterials = materials?.filter(m => m.checked) || [];
    const DEFAULT_MATERIAL_SKU = selectedMaterials[0]?.sku_code || '';
    const selectedColors = colors?.reduce((acc, c) => c.checked ? [...acc, c.sku_code] : acc, []) || [];
    if (profiles) {
        profiles?.forEach(profile => {
            if (profile.checked) {
                profile.children.forEach(width => {
                    if (width.checked) {
                        if(!isInside) {
                            selectedMaterials.forEach(material => {
                                material.color_options.forEach(color => {
                                    if(color.sku_code === 'NONE' || material.sku_code === DEFAULT_MATERIAL_SKU) {
                                        if(selectedColors.includes(color.sku_code)) {
                                            selectedMappings.push({ 
                                                key: `${profile.id}-${width.id}-${material.id}-color-${color.sku_code}`,
                                                profile,
                                                width,
                                                material,
                                                color
                                            });
                                        }
                                    }
                                });
                            });
                        } else {
                            selectedMaterials.forEach(material => {
                                if(material.sku_code === DEFAULT_MATERIAL_SKU) {
                                    selectedMappings.push({ 
                                        key: `${profile.id}-${width.id}-${material.id}`,
                                        profile,
                                        width,
                                        material
                                    });
                                }
                            });
                        }
                    }
                });
            }
        });
    }
    return selectedMappings;
};

export const getConfigMapping = (mappingData, isInside = false) => {
    const { profiles, materials } = mappingData;
    const configMapping = {};
    if(profiles) {
        profiles?.forEach(profile => {
            configMapping[profile.sku_code] = profile.children.map(width => {
                if(!isInside) {
                    const {color_options, profiles, ...material} = materials?.[0] || {};
                    const color = color_options?.find(c => c.sku_code !== 'NONE') || color_options?.[0] || {};
                    return { 
                        key: `${profile.sku_code}-${width.sku_code}-${material.sku_code}-${color.sku_code || ''}`,
                        profile,
                        width,
                        material,
                        color
                    }
                } else {
                    const {profiles, ...material} = materials?.[0]
                    return { 
                        key: `${profile.sku_code}-${width.sku_code}-${material.sku_code}`,
                        profile,
                        width,
                        material
                    }
                }
            });
        });
    }
    return configMapping;
}
export const updateMappingChecked = (mappingData, type, id, checked) => {
    switch (type) {
        case 'profile':
            return {
                ...mappingData,
                profiles: mappingData.profiles.map(profile => profile.id === id ? { ...profile, checked } : profile)
            };
        case 'width':
            return {
                ...mappingData,
                profiles: {
                    ...mappingData.profiles,
                    children: mappingData.profiles.map(profile => {
                        return {
                            ...profile,
                            children: profile.children.map(width => width.id === id ? { ...width, checked } : width)
                        }
                    })
                }
            };
        case 'color':
            return {
                ...mappingData,
                colors: mappingData.colors.map(color => color.id === id ? { ...color, checked } : color)
            };
        case 'material':
            return {
                ...mappingData,
                materials: mappingData.materials.map(material => material.id === id ? { ...material, checked } : material)
            };
        default:
            return mappingData;
    }
};